import { Controller } from "@hotwired/stimulus";
import { getCSRFToken } from "web-ui/csrf"
import * as Log from "web-ui/log"

// Connects to data-controller="show-popover"
export default class extends Controller {
  static values = {
    alignment: String,
    url: String
  }

  connect() {
    this.debug("Connect", { alignment: this.alignmentValue, url: this.urlValue })

    this.element.addEventListener("click", this.openPopover)
  }

  openPopover = async () => {
    if (this.isPopoverOpen()) {
      return
    }

    const csrfToken = getCSRFToken()

    const headers = {
      "Accept": "text/vnd.turbo-stream.html",
      "X-CSRF-Token": csrfToken
    }

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("target", this.element.id)

    if (this.alignmentValue) {
      url.searchParams.set("alignment", this.alignmentValue)
    }

    try {
      const response = await fetch(url, { headers, method: "GET" })

      const responseContentType = response.headers.get("Content-Type")

      if (!this.isTurboStreamContentType(responseContentType)) {
        this.debug("Response error: ", { response })
        return
      }

      const html = await response.text()

      this.debug("Rendering")

      Turbo.renderStreamMessage(html)
    } catch(error) {
      Sentry.captureException(error)
    }
  }

  isPopoverOpen() {
    const popover = document.querySelector(`[popover][data-target='${this.element.id}']`)

    return !!popover
  }

  isTurboStreamContentType(contentType) {
    return contentType.match("turbo-stream.html") !== null
  }

  disconnect() {
    this.debug("Disconnect")

    const popover = document.querySelector(`[popover][data-target='${this.element.id}']`)

    if (popover) {
      popover.remove()
    }

    this.element.removeEventListener("click", this.openPopover)
  }

  debug(message, data={}) {
    Object.assign(data, {
      id: this.element.id
    })

    Log.debug("Show Popover - " + message, data)
  }
}
